import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { RawIntlProvider } from 'react-intl'

import { QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'

import App from './App'
import { store } from 'app/state/store'
import { queryClient } from './queryClient'
import { RootDialogs } from './features/dialogs'

import Auth0ProviderWithUser from 'app/ui/Auth0ProviderWithUser'
import { buildCustomTimeAgoEnLabels } from 'app/ui/configureTimeAgo'
import { register } from 'timeago.js'
import { registerTrackers } from 'app/trackers'
import intl from 'app/localization/intl'

import './index.css'
import { validateLocalStorage } from 'app/api/localStorage'
import './testHelpers'

// Required indirectly by ReactMarkdown used in kepler.gl
import processPolyfill from 'process/browser'
import CloudNativeThemeProvider from 'features/common/ui/theme/CloudNativeThemeProvider'
import Notification from 'features/notifications/ui/Notification/Notification'
import JobNotification from 'features/notifications/ui/Notification/JobNotification'
import settings, { DEFAULT_AUTHORIZATION_HEADER } from 'settings'
import { overrideDefaultAuthorizationHeaderName } from 'app/utils/custom-auth-header'

window.process = processPolyfill

// These two functions are overriding the browser fetch function to add some logging
// or replace the authorization header name. It could be possible that in a dev environment
// they're both being used at the same time, so check them in case you see weird behaviors in dev.
registerTrackers()
if (settings.authorizationHeader !== DEFAULT_AUTHORIZATION_HEADER) {
  overrideDefaultAuthorizationHeaderName(settings.authorizationHeader)
}

register('en_US', buildCustomTimeAgoEnLabels)

validateLocalStorage()

if (settings.commitHash) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ;(window as any).CARTO = { version: settings.commitHash || settings.cartoVersion }
}

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <BrowserRouter>
        <Auth0ProviderWithUser>
          <RawIntlProvider value={intl}>
            <CloudNativeThemeProvider>
              <Notification />
              <JobNotification />
              <RootDialogs />
              <App />
            </CloudNativeThemeProvider>
          </RawIntlProvider>
        </Auth0ProviderWithUser>
      </BrowserRouter>
    </Provider>
    <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
  </QueryClientProvider>,
  document.getElementById('root')
)
